/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

/* Component Imports */

import { Paper, Typography } from "@material-ui/core";

/* Data Imports */

import AppConfig from "../../../AppConfig";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "1.5rem",
    marginBottom: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  heading: {
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    marginBottom: "1rem",
  },
  cardsHolderHolder: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  cardsHolder: {
    display: "flex",
    flexDirection: "row",
    alignItems: "normal",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    gap: "1rem",
  },
  card: {
    padding: "1rem",
    width: "48%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  grpTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    textTransform: "capitalize",
  },
  category: {
    marginLeft: "0.5rem",
    fontWeight: 500,
    fontSize: "1.25rem",
    lineHeight: "1.875rem",
    letterSpacing: "0.009rem",
  },
  nameDistanceRow: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  name: {
    width: "75%",
  },
  distance: {
    fontWeight: 600,
  },
}));

const DispenseIcon = (icon = "vicinity/restaurant") => {
  switch (icon) {
    case "vicinity/university":
      return "/images/icons/vicinity/university.svg";
    case "vicinity/health":
      return "/images/icons/vicinity/health.svg";
    case "vicinity/mall":
      return "/images/icons/vicinity/mall.svg";
    case "vicinity/restaurant":
      return "/images/icons/vicinity/restaurant.svg";
    default:
      return "/images/icons/vicinity/restaurant.svg";
  }
};

const calculateCategoryIcon = (category) => {
  switch (category) {
    case "schools":
      return "vicinity/university";
    case "hospitals":
      return "vicinity/health";
    case "malls":
      return "vicinity/mall";
    case "others":
      return "vicinity/restaurant";
    default:
      return "vicinity/restaurant";
  }
};

const sortVicinityByDistance = (array) => {
  return array.sort((a, b) => (a.distance < b.distance ? 1 : -1));
};

const Vicinity = (props) => {
  const classes = useStyles();

  if (!props.loading) {
    return (
      <React.Fragment>
        <Paper elevation={2} className={classes.paper}>
          <Typography variant="body2" component="p" className={classes.heading}>
            Vicinity
          </Typography>
          <div className={classes.cardsHolderHolder}>
            <div className={classes.cardsHolder}>
              {props.vicinity.map((object, key) => {
                return (
                  <Paper elevation={2} className={classes.card} key={key}>
                    <div className={classes.grpTitle}>
                      <img
                        alt={AppConfig.imageAltText}
                        loading="lazy"
                        referrerPolicy="no-referrer"
                        height={30}
                        width={30}
                        src={DispenseIcon(
                          calculateCategoryIcon(object.category),
                        )}
                      />
                      <Typography
                        variant="body2"
                        component="p"
                        className={classes.category}
                      >
                        {object.category}
                      </Typography>
                    </div>
                    {sortVicinityByDistance(object.values).map((obj, k) => (
                      <p className={classes.nameDistanceRow} key={k}>
                        <span className={classes.name}>{obj.title}</span>
                        <span className={classes.distance}>
                          {obj.distance ? obj.distance + " KM" : undefined}
                        </span>
                      </p>
                    ))}
                  </Paper>
                );
              })}
            </div>
          </div>
        </Paper>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Paper elevation={2} className={classes.paper}>
          <Skeleton>
            <Typography
              variant="body2"
              component="p"
              className={classes.heading}
            >
              Vicinity
            </Typography>
          </Skeleton>
          <div className={classes.cardsHolderHolder}>
            <div className={classes.cardsHolder}>
              {props.vicinity.map((object, key) => {
                return (
                  <Paper elevation={2} className={classes.card} key={key}>
                    <Skeleton>
                      <div className={classes.grpTitle}>
                        <img
                          alt={AppConfig.imageAltText}
                          loading="lazy"
                          referrerPolicy="no-referrer"
                          height={30}
                          width={30}
                          src={DispenseIcon(
                            calculateCategoryIcon(object.category),
                          )}
                        />
                        <Typography
                          variant="body2"
                          component="p"
                          className={classes.category}
                        >
                          {object.category}
                        </Typography>
                      </div>
                    </Skeleton>
                    {sortVicinityByDistance(object.values).map((obj, k) => (
                      <p className={classes.nameDistanceRow} key={k}>
                        <Skeleton>
                          <span className={classes.name}>{obj.title}</span>
                        </Skeleton>
                        <Skeleton>
                          <span className={classes.distance}>
                            {obj.distance ? obj.distance + " KM" : undefined}
                          </span>
                        </Skeleton>
                      </p>
                    ))}
                  </Paper>
                );
              })}
            </div>
          </div>
        </Paper>
      </React.Fragment>
    );
  }
};

export default Vicinity;
